import { setHeader } from '@/util/set-header';
import React from 'react';
import "./lineup.less";
import { withRouter } from "react-router";
import  moment  from "moment";
import { NoticeBar, Steps, Button, Modal, Toast } from "antd-mobile";
import { cancelLineupApi, prolongLineupApi, lineupInfoApi } from "@/api/sany";
import { PhotoProvider, PhotoConsumer } from 'react-photo-view';
const Step = Steps.Step

@(withRouter as any)
export default class Relet extends React.Component<any,any> { 
  state = {
    notice: '排队领号成功，宿管会依次处理，请耐心等候~',
    detail: {
      is_bpm: '',
      reject_reason: '',
      status: '',
      status_name: '',
      add_time: '',
      update_time: '',
      img: [],
      is_notice: '',
      renewal: false, // 是否展示续期按钮
      code: '',
      node_name: '',
      node_phone: '',
      queue_count: '',
      checkin_day: '',
      storeName: '',
      room_property_name: '',
      notice_time: ''
    }
  }
  // detail: any = {primary_room: {}, apply_room: {}}
  constructor(prop: any) {
    super(prop)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
  }

  componentDidMount() {
    setHeader({title: '排队', leftToHome: this.goHomePage, leftClick: this.leftClick})
    this.fetchDetail()
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  // 滚动通知栏
  noticeBarComponent() {
    return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>{this.state.notice}</NoticeBar>
  }

   // 步骤条
   stepComponent() {
    // 1：待审核2：排队中 3：待入住 4：已入住 5：已驳回 6：已失效 7:已取消
    const status2 = this.state.detail.status !== '' ? 'finish' : 'wait'
    const status = this.state.detail.status !== '' ? ((this.state.detail.status !== '1' && this.state.detail.status !== '2') ? 'finish' : 'wait') : 'wait'
    const title = this.state.detail.status !== '' ? (this.state.detail.status !== '1' && this.state.detail.status !== '2' ? this.state.detail.status_name : '办理入住') : '办理入住'
    const step2Icon = this.state.detail.status !== '' ? '/public/assets/img/step_loading_select.png' : '/public/assets/img/step_loading.png'
    let step3Icon = '/public/assets/img/checkin_bed.png'
    if (this.state.detail.status === '3' || this.state.detail.status === '4') {
      step3Icon = '/public/assets/img/checkin_bed_a.png'
    } else if (this.state.detail.status === '1' || this.state.detail.status === '2') {
      step3Icon = '/public/assets/img/checkin_bed.png'
    } else if (this.state.detail.status === '5' || this.state.detail.status === '6' || this.state.detail.status === '7') {
      step3Icon = '/public/assets/img/step_end.png'
    } else {
      step3Icon = '/public/assets/img/checkin_bed.png'
    }
    const applyTime = this.state.detail.add_time ? moment(this.state.detail.add_time).format('yyyy-MM-DD') : ''
    const endTime = (this.state.detail.status === '1' || this.state.detail.status === '2' || this.state.detail.status === '3' ) ? '' : moment(this.state.detail.update_time).format('yyyy-MM-DD')
    return (
      <div className="step-body">
        <Steps direction="horizontal" size="small">
          <Step status="finish" title={this.customTitle('开始排队', 'finish')} description={this.customDesc(applyTime, 'finish')} icon={this.customIcon('/public/assets/img/step_start_select.png')} />
          <Step status="wait" title={this.customTitle('排队中', status2)} description={this.customDesc('', status2)} icon={this.customIcon(step2Icon)} />
          <Step status="wait" title={this.customTitle(title, status)} description={this.customDesc(endTime, status)} icon={this.customIcon(step3Icon)} />
        </Steps>
      </div>
    )
  }

  customTitle(title: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <div style={{fontSize:'12px', color: color}}>{title}</div>
    )
  }

  customDesc(desc: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <span style={{color: color, fontSize: '12px'}}>{desc}</span>
    )
  }

  customIcon(img: string) {
    return (
      <img src={img} alt="" style={{width: '25px', height: '25px'}}/>
    )
  }

  // 租约状态
  leaseStatusComponent() {
    let statusClassName = 'status-text '
    switch (this.state.detail.status) {
      case '1':
      case '2':
        if (this.state.detail.is_notice === '2') {
          statusClassName += 'has-noticed'
        } else {
          statusClassName += 'liveing'
        }
        break;
      case '3':
        statusClassName += 'liveing'  
        break
      case '5':
      case '6':
      case '7':
        statusClassName += 'invalid'
        break
      default:
        break;
    }
    return (
      <div className="component-body">
        <div className="lease-status">
          <span style={{fontSize: '14px', color: '#515151'}}>租约状态：</span>
          <span className={statusClassName}>{this.state.detail.status_name}</span>
        </div>
      </div>
    )
  }

  lineupNoticeComponent() {
    return (
      <div className="component-body">
        <div className="lineup-notice">
          <span style={{fontSize:'14px', color: '#333333'}}>请于<span style={{color: '#0066cc',fontSize: '14px'}}>{this.state.detail.notice_time}</span>前办理入住</span>
        </div>
      </div>
    )
  }

  // 排队中信息
  lineupInfoComponent() {
    const applyTime = this.state.detail.add_time ? moment(this.state.detail.add_time).format('yyyy-MM-DD') : ''
    const endTime = this.state.detail.checkin_day ? moment(this.state.detail.checkin_day).format('yyyy-MM-DD') : ''
    return (
      <div className="component-body">
        <div className="lineup-info">
          {this.state.detail.status === '2' ? <div className="between-row" style={{height: '40px'}}>
            <span style={{color: '#434343', fontSize: '14px'}}>前方正在等待：</span>
            <span style={{color: '#48bdb5', fontSize: '16px'}}>{this.state.detail.queue_count}人</span>
          </div> : null}
          <div className="between-row" style={{height: '40px'}}>
            <span style={{color: '#434343', fontSize: '14px'}}>排队号码：</span>
            <span style={{color: '#868686', fontSize: '16px'}}>{this.state.detail.code}</span>
          </div>
          <div className="between-row" style={{height: '40px'}}>
            <span style={{color: '#434343', fontSize: '14px'}}>排队时间：</span>
            <span style={{color: '#868686', fontSize: '14px'}}>{applyTime}-{endTime}</span>
          </div>
          <div className="between-row" style={{height: '40px'}}>
            <span style={{color: '#434343', fontSize: '14px'}}>节点处理人：</span>
            <span style={{color: '#868686', fontSize: '14px'}}>{this.state.detail.node_name}</span>
          </div>
          <div className="between-row" style={{height: '40px'}}>
            <span style={{color: '#434343', fontSize: '14px'}}>节点处理人电话：</span>
            <span style={{color: '#868686', fontSize: '13px'}}><a href={`tel:${this.state.detail.node_phone}`}>{this.state.detail.node_phone}</a></span>
          </div>
        </div>
      </div>
    )
  }

  // 预定房间信息
  dormInfoComponent() {
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-top">
            <span style={{color: '#868686', fontSize: '16px'}}>{this.state.detail.storeName}</span>
            {/* <span style={{color: '#1b1b1b', fontSize: '14px'}}>{this.detail.building_no} {this.detail.room_no} {this.detail.bed_no}</span> */}
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>入住类型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>员工宿舍</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>预订房型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.state.detail.room_property_name}</span>
            </div>
          </div>
          <div className="dorm-info-bottom">
            <span style={{color: '#434343', fontSize: '13px'}}>附件：</span>
            {this.attachmentImageList()}
          </div>
        </div>
      </div>
    )
  }

  // 构建图片数组
  attachmentImageList() {
    const imgs: any[] = this.state.detail.img.length > 0 ? this.state.detail.img : []
    return (
      <PhotoProvider>
      {imgs.map((item: any, index) => (
        <PhotoConsumer key={index} src={item} intro={item}>
          <img src={item} alt="" style={{width: '47px', height: '55px', marginLeft: '10px'}}/>
        </PhotoConsumer>
      ))}
    </PhotoProvider>
    )
  }

  calcDays() {
    const day1 = '2020-01-01'
    const day2 = '2020-01-08'
    const date1 = Date.parse(day1)
    const date2 = Date.parse(day2)
    const gap = Math.floor((date2 - date1) / (24 * 3600 * 1000))
    return gap
  }

  submitButton() {
    if (this.state.detail.status === '5' || this.state.detail.status === '6' || this.state.detail.status === '7') {
      return (
        <div className="bottom-btns">
          <Button className="submit-btn"  onClick={() => this.recycleClick()}>重新申请</Button>
        </div>
      )
    } else if ((this.state.detail.status === '1' || this.state.detail.status === '2' || this.state.detail.status === '3')) {
      let title =  '取消排队'
      return (
        <div className="bottom-btns">
          {this.state.detail.renewal ? <Button className="submit-btn"  onClick={() => this.continueClick()}>续期</Button> : null }
          <Button className="submit-btn"  onClick={() => this.submitClick()}>{title}</Button>
        </div>
      )
    }
  }

  recycleClick() {
    sessionStorage.setItem('reservationType', 'reservation')
    this.props.history.push({ pathname: '/sany/book-room',state: {propertyType:'3'}})
  }
  
  continueClick() {
    Modal.alert('排队续期', '确认续期后，排队时间将自动增加3个月，确认续期？', [
      { text: '暂不续期', onPress: () => console.log('cancel') },
      { text: '确认续期', onPress: () => this.submitProlong() },
    ])
  }

  submitClick() {
    Modal.alert('取消排队', '确定取消排队？', [
      { text: '取消', onPress: () => console.log('cancel') },
      { text: '确定', onPress: () => this.submitCancelLineup() },
    ])
  }

  async submitCancelLineup() {
    const id = this.props.location.query.id
    Toast.loading('操作中...')
    const {data} = await cancelLineupApi({ id })
    Toast.hide()
    if (data.code === 'SUCCESS') {
      Toast.info('取消成功~')
      this.props.history.goBack()
    }
  }

  async submitProlong() {
    const id = this.props.location.query.id
    Toast.loading('操作中...')
    const {data} = await prolongLineupApi({id})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      Toast.info('成功延期3个月~')
      this.fetchDetail()
    }
  }

  async fetchDetail() {
    const id = this.props.location.query.id
    Toast.loading('加载中...')
    const {data} = await lineupInfoApi({id})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      this.setState({
        detail: data.data
      })
    } else if (data.msg) {
      Toast.info(data.msg)
    } else {
      Toast.info('接口请求失败，请重新打开页面~')
    }
  }
  // 驳回原因
  rejectReasonComponent() {
    return (
      <div className="component-body">
        <div className="lease-status">
          <span style={{fontSize: '14px', color: '#515151', width: '100px'}}>驳回原因：</span>
          <span style={{color: '#868686', fontSize: '12px', overflowWrap: 'break-word', width: '250px', textAlign: 'right'}}>{this.state.detail.reject_reason}</span>
        </div>
      </div>
    )
  }
  render() {
    return (
      <div className="lineup-detail">
        {this.state.detail.status === '1' || this.state.detail.status === '2' || this.state.detail.status === '3' ? this.noticeBarComponent() : null}
        {this.stepComponent()}
        {this.state.detail.is_bpm === '1' && this.state.detail.status_name === '已驳回' ? this.rejectReasonComponent() : this.leaseStatusComponent()}
        {this.state.detail.status === '3' ? this.lineupNoticeComponent() : null}
        {this.lineupInfoComponent()}
        {this.dormInfoComponent()}
        {this.submitButton()}
      </div>
    )
  }

}